import { useState, type ComponentProps } from 'react';
import type { SxProps, Theme } from '@mui/material';

import { DatePicker } from '@theguarantors/tg-package-material-ui';

export type RenterInviteDatePickerProps = Omit<ComponentProps<typeof DatePicker>, 'label'> & {
  label?: string;
  sx?: SxProps<Theme>;
  error?: string;
};

export const RenterInviteDatePicker = ({
  label = '',
  sx = {},
  slotProps,
  error,
  ...props
}: RenterInviteDatePickerProps) => {
  const [isFocused, setIsFocused] = useState(false);

  return (
    <DatePicker
      color="secondary"
      label={label}
      {...props}
      slotProps={{
        ...slotProps,
        textField: {
          required: true,
          size: 'small',
          error: Boolean(error),
          helperText: error || 'MM/DD/YYYY',
          onFocusCapture: () => setIsFocused(true),
          onBlurCapture: () => setIsFocused(false),
          placeholder: '',
          InputLabelProps: {
            shrink: Boolean(props.value) || isFocused,
          },
          ...slotProps?.textField,
          sx: {
            '& .MuiInputBase-input::placeholder': {
              opacity: 1,
            },
            '& .MuiFormLabel-asterisk': {
              color: 'red !important',
            },
            '& .MuiFormHelperText-root': {
              fontSize: '12px',
              lineHeight: '20px',
            },
            ...sx,
          },
        },
      }}
    />
  );
};
